// extracted by mini-css-extract-plugin
export var welcome = "ProWelcome-module__welcome___LqB2v";
export var content = "ProWelcome-module__content___Uckq0";
export var img = "ProWelcome-module__img___MHtH4";